(ns hai.notes.helpers
  (:require
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]))

(def ->label :note/text)

(def icon icons/humble-note)

(defn ->icon
  [_note]
  icon)

(defn ->tint
  [_]
  t/--notes)
